import { useEffect } from 'react'

import { useMeMutation } from '@/src/features/auth/services/useMeMutation'
import { getIsLoggedIn } from '@/src/features/auth/utils/getIsLoggedIn'
import { guessTimezone } from '@/src/general/primitives/dates/dayjs'
import { getAppType } from '@/src/general/utils/getAppType'

export const usePatchMeAppType = () => {
  const { mutate: mutateMe } = useMeMutation()

  useEffect(() => {
    if (getIsLoggedIn()) mutateMe({ appType: getAppType(), timezone: guessTimezone() })
  }, [mutateMe])
}
